import { Component } from '@theme/component';
import { DialogComponent } from '@theme/dialog';

/**
 * `<micronutrients-section>` — the "Wir testen auf …" category chip grid.
 *
 * The chips and both dialogs are server-rendered in the section; this
 * component only fills the shared item dialog with the clicked chip's data
 * and proxies the primary CTA to the page's add-to-cart button on PDPs.
 *
 * @extends {Component}
 */
class MicronutrientsSection extends Component {
  /**
   * Fills the shared item dialog with the clicked chip's data and opens it.
   *
   * @param {MouseEvent} event
   */
  openItemDialog(event) {
    const chip = event.target;
    if (!(chip instanceof HTMLElement)) return;

    const dialog = this.querySelector('.micro-item-dialog');
    if (!(dialog instanceof DialogComponent)) return;

    const { itemIcon, itemTitle, itemDescription, itemSubstances } = dialog.refs;
    const icon = chip.querySelector('.micro-icon');

    if (itemIcon instanceof HTMLImageElement) {
      if (icon instanceof HTMLImageElement) {
        itemIcon.src = icon.src;
        itemIcon.hidden = false;
      } else {
        itemIcon.removeAttribute('src');
        itemIcon.hidden = true;
      }
    }
    if (itemTitle instanceof HTMLElement) itemTitle.textContent = chip.dataset.itemTitle ?? '';
    if (itemDescription instanceof HTMLElement) itemDescription.textContent = chip.dataset.itemDescription ?? '';
    if (itemSubstances instanceof HTMLElement) itemSubstances.textContent = chip.dataset.itemSubstances ?? '';

    dialog.showDialog();
  }

  /**
   * Primary CTA: on pages with an add-to-cart button (PDPs) the CTA proxies
   * to it instead of navigating; elsewhere the link behaves normally.
   *
   * @param {MouseEvent} event
   */
  triggerAddToCart(event) {
    const addToCartButton = document.querySelector('.button.add-to-cart-button');
    if (!(addToCartButton instanceof HTMLElement)) return;

    event.preventDefault();
    addToCartButton.click();
  }
}

if (!customElements.get('micronutrients-section')) {
  customElements.define('micronutrients-section', MicronutrientsSection);
}
